import "./App.css";
import SignUp from "./Component/SignUp/SignUp";

function App() {
	return (
		<div className="App">
			<SignUp />
		</div>
	);
}

export default App;
